module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown-view-box"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./editor.md/css/editormd.min.css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./css/tw-markdown-view.css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./editor.md/css/editormd.preview.min.css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "markdown-view"
    }
  }, [_c('textarea', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.doc.content))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-15057f83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tw-markdown-view.vue
// module id = 588
// module chunks = 1